import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as BackArrow } from "../../../../../../assets/img/svg/BackArrow.svg";
import FilterForm from "./FilterForm";
import ListComponent from "./ListComponent";
import { fetchAllPostPromisedData } from "../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../common/constant";
import {
  getDropdowns,
  FILTER__FORM_FIELDS_GLOBAL,
  dateControlDropdown,
} from "./constants";
import { getFilterCount } from "../../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import moment from "moment";
import { successToast } from "../../../common/utils/methods/toasterFunctions/function";

const ChargeModification = ({ forPANIndia = false, dropdownData }) => {
  // const history = useHistory();
  const ref = useRef();

  const [loading, setLoading] = useState([]);
  // const [dropdownData, setDropdownData] = useState([]);
  const [charges, setCharges] = useState([]);
  const [filterForm, setFilterForm] = useState({
    ...FILTER__FORM_FIELDS_GLOBAL,
  });
  const [filterCount, setFilterCount] = useState(
    getFilterCount({ ...filterForm }, [
      "postCourseStartDays",
      "modLimit",
      "effectiveDate",
    ]),
  );

  const [paginationInfo, setPaginationInfo] = useState({
    currentPage: 0,
    totalRecords: 0,
  });

  const pageChangeHandler = (newPage) => {
    applyFilterHandler(newPage);
  };

  // callback function for seach filter
  const applyFilterHandler = (pageNumber = 0, reqObj = {}) => {
    const { businessArea, academicCareer, ticketId, startDate, endDate } =
      reqObj;
    const filterObj = {
      ...(businessArea && {
        businessAreaIds: businessArea?.map((bu) => bu.value),
      }),
      ...(academicCareer && {
        academicCareerIds: academicCareer?.map((ca) => ca.value),
      }),
      ...(startDate && { startDate: startDate }),
      ...(endDate && { endDate: endDate }),
      ...(ticketId && { ticketId: ticketId }),
    };

    getAllCharges(filterObj, pageNumber);
  };

  const init = async () => {
    try {
      setLoading(true);
      // const dropdownData = await getDropdowns();
      // setDropdownData(dropdownData);
      getAllCharges({}, 0, dropdownData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // get ALL Charge Mapping from API
  const getAllCharges = async (
    filterObj = {},
    pageNumber = 0,
    dropdowns = dropdownData,
  ) => {
    try {
      setLoading(true);

      const businessAreaIds = forPANIndia
        ? [0]
        : filterObj?.businessAreaIds?.length > 0
          ? filterObj?.businessAreaIds
          : dropdowns?.allActiveBu?.map((bu) => bu?.value);

      const reqObj = {
        ...filterObj,
        pageNo: pageNumber,
        businessAreaIds,
      };

      const resp = await fetchAllPostPromisedData(
        `${endpoint.chargeModification.search}`,
        reqObj,
        "post",
      );
      if (resp?.code === 200) {
        const updatedData = resp?.data?.chargeModConfigs?.map(
          ({
            businessAreaId,
            businessAreaDispVal,
            academicCareerId,
            academicCareerDispVal,
            dateControl,
            ...rest
          }) => ({
            ...rest,
            academicCareer: {
              value: academicCareerId || "",
              label: academicCareerDispVal || "",
            },
            // chargeModConfTermMappings: rest?.chargeModConfTermMappings?.map(
            //   (obj) => ({
            //     label: obj.term,
            //     value: obj.termId,
            //   }),
            // ),
            // chargeModConfCourseCategoryMappings:
            //   rest?.chargeModConfCourseCategoryMappings?.map((obj) => ({
            //     label: obj.courseCategory,
            //     value: obj.courseCategoryId,
            //   })),
            businessArea: dropdowns?.allActiveBu?.find(
              (bu) => bu?.value == businessAreaId,
            ),
            dateControl: dateControlDropdown?.find(
              (el) => el?.value === dateControl,
            ),
          }),
        );

        setCharges(updatedData);
        setPaginationInfo({
          currentPage: resp?.data?.currentPage,
          totalPage: resp?.data?.totalPage,
          totalRecords: resp?.data?.totalRecords,
        });
        ref.current.stopEditing();
      }

      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const createUpdateHandler = async (rowForm) => {
    try {
      setLoading(true);

      let url = endpoint.chargeModification.create;
      let method = "post";

      if (!rowForm.isNew) {
        url = endpoint.chargeModification.update;
        method = "put";
      }

      const {
        academicCareer,
        businessArea,
        postCourseStartDays,
        description,
        modLimit,
        ticketId,
        id,
        status,
        applicationLevel,
        applicationList,
        dateControl,
        // chargeModConfTermMappings,
        // chargeModConfCourseCategoryMappings,
      } = rowForm;
      const updatedApplicationList =
        applicationLevel === "NO" ? [] : applicationList;

      const reqObj = {
        academicCareerId: academicCareer?.value,
        academicCareerDispVal: academicCareer?.label,
        businessAreaId: businessArea?.value,
        businessAreaDispVal: businessArea?.label,
        postCourseStartDays,
        description,
        modLimit,
        ticketId,
        id,
        status,
        applicationLevel,
        applicationList: updatedApplicationList,
        dateControl: dateControl?.value,
        // chargeModConfTermMappings: chargeModConfTermMappings?.map((obj) => ({
        //   termId: obj.value,
        //   term: obj.label,
        // })),
        // chargeModConfCourseCategoryMappings:
        //   chargeModConfCourseCategoryMappings?.map((obj) => ({
        //     courseCategoryId: obj.value,
        //     courseCategory: obj.label,
        //   })),
        ...(forPANIndia && { businessAreaId: 0, businessAreaDispVal: "PAN" }),
      };

      const resp = await fetchAllPostPromisedData(url, reqObj, method);

      if (resp?.code === 200) {
        getAllCharges();
        successToast("Request completed successfully!!!");
        ref.current.stopEditing();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    Object.keys(dropdownData).length > 0 && init();
  }, [dropdownData]);

  return (
    <>
      <Card className="mx-2">
        <div className="d-flex justify-content-between my-3 mx-2">
          <div className="d-flex justify-content-between">
            {/* <BackArrow
              className="color-black mr-2 cursor"
              onClick={() => history.goBack()}
            /> */}
            <h4 className="color-black">
              {forPANIndia
                ? "PAN India Configuration"
                : "Branch level exceptions"}
            </h4>
          </div>
          <div className="d-flex justify-content-between">
            {/* <ShowOnlyPendingRequestsCheckbox
              // checked={showOnlyPendingRequests}
              // showOnlyPendingRequestsHandler={showOnlyPendingRequestsHandler}
              label="Show only expired"
            /> */}
            {/* <SearchInput
              inputStyles={{ border: "1px solid #000" }}
              placeholder={"Search"}
              //  searchInputValueHandler={searchHandler}
              //  onCancel={cancelSearchHandler}
            /> */}
            <APopover
              buttonComponent={(onClick, styles) => (
                <AButton
                  className="tiny-semi-bold color-dark"
                  onClick={onClick}
                  updatedStyle={{
                    minWidth: "61px",
                    ...(filterCount > 0
                      ? {
                          border: "1px solid #00B0F5",
                          color: "#00B0F5",
                        }
                      : styles),
                  }}
                >
                  Filter {filterCount > 0 && <>( {filterCount} )</>}
                </AButton>
              )}
              menuComponent={(closePopup) => (
                <FilterForm
                  closePopup={closePopup}
                  dropdownData={dropdownData}
                  filterForm={filterForm}
                  filterCount={filterCount}
                  setFilterCount={setFilterCount}
                  setFilterForm={setFilterForm}
                  applyFilterHandler={applyFilterHandler}
                  forPANIndia={forPANIndia}
                />
              )}
            />
            <AButton
              variant="primary_filled"
              onClick={() => ref.current.addNewRow()}
              size="xs"
            >
              + Add configuration
            </AButton>
          </div>
        </div>

        <ListComponent
          rows={charges}
          ref={ref}
          loading={loading}
          setLoading={setLoading}
          currentPage={paginationInfo.currentPage}
          totalRecords={paginationInfo.totalRecords}
          pageChangeHandler={pageChangeHandler}
          dropdownData={dropdownData}
          createUpdateHandler={createUpdateHandler}
          forPANIndia={forPANIndia}
        />
      </Card>
    </>
  );
};

export default ChargeModification;
